/**
 * IndexedDB indisponível (cota excedida, erro de permissão, corrupção do
 * banco) — CA-03. Quem captura este erro cancela o POST/gravação em curso e
 * registra um log estruturado em `console.error`, sem expor nada em UI (o
 * operador só vê o indicador 🔴 offline).
 */
export class IndexedDbUnavailableError extends Error {
  constructor(message: string, cause?: unknown) {
    super(message, cause === undefined ? undefined : { cause });
    this.name = 'IndexedDbUnavailableError';
  }
}
